import { RadioButton } from 'src/modules/common/components/Radio/RadioButton';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { SelectNominalVoltage } from 'src/modules/checkout/types';
import { I18n } from 'src/modules/common/components/I18n/I18n';

export type BooleanOptionProps = {
    value: SelectNominalVoltage;
    onChange: (voltage: SelectNominalVoltage) => void;
}

export const SelectVoltage = ({ value, onChange }: BooleanOptionProps) => (
    <div className="vss-select-voltage">
        <p className="vss-select-voltage__description">
            <I18n messageId={MESSAGES.revitPluginVoltage}/>
        </p>

        <div className="vss-select-voltage__actions">
            <RadioButton
                id="v_24"
                name="nominalVoltage"
                onChange={() => onChange('24 V')}
                checked={value === '24 V'}
            >
                24 V
            </RadioButton>

            <RadioButton
                checked={value === '230 V'}
                id="v_230"
                name="nominalVoltage"
                onChange={() => onChange('230 V')}
            >
                230 V
            </RadioButton>
        </div>
    </div>
);
